export default __webpack_public_path__ + "static/media/v-bar-stack.e291b3f8.svg";